import { atom } from 'jotai';

import { HardwareSection } from '../types/sidecar';

import { atomFromQueryString } from '~/shared/state';

export const $currentSection = atomFromQueryString.string(
  'hwSection',
) as unknown as ReturnType<typeof atom<HardwareSection | null>>;
